module.exports = __webpack_public_path__ + "img/render-image.81786d5b.png";